import React, { useState } from 'react';
import { signInWithGoogle, signInWithFacebook } from '../lib/auth.js';

export function LoginPage() {
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(null);

  async function handleGoogle() {
    setLoading('google');
    setError(null);
    try {
      await signInWithGoogle();
      // Redirect happens automatically — the user is sent to Google
    } catch (e) {
      console.error(e);
      setError('Kunne ikke starte Google login. Prøv igen.');
      setLoading(null);
    }
  }

  async function handleFacebook() {
    setLoading('facebook');
    setError(null);
    try {
      await signInWithFacebook();
    } catch (e) {
      console.error(e);
      setError('Kunne ikke starte Facebook login. Prøv igen.');
      setLoading(null);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: 24,
      background: 'linear-gradient(180deg, #0F0E0D, #1A1612)',
    }}>
      <div style={{ maxWidth: 380, width: '100%' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <a href="/" style={{
            display: 'inline-block',
            marginBottom: 24,
            fontSize: 12,
            color: '#A19B8F',
            textDecoration: 'none',
          }}>← Tilbage til forsiden</a>
          <svg width="100" height="100" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', margin: '0 auto 16px' }}>
            <g transform="translate(60,60)">
              <rect x="-30" y="-20" width="20" height="40" rx="3" fill="#FF5A4E"/>
              <rect x="-36" y="-20" width="32" height="9" rx="3" fill="#FF5A4E"/>
              <rect x="6" y="-22" width="20" height="40" rx="3" fill="#FFB627"/>
              <rect x="0" y="-22" width="32" height="9" rx="3" fill="#FFB627"/>
            </g>
          </svg>
          <h1 style={{ fontSize: 32, fontWeight: 800, letterSpacing: -1, margin: 0, color: '#F5F2EC' }}>Tag Team</h1>
          <p style={{ fontSize: 13, color: '#A19B8F', marginTop: 6, fontWeight: 500 }}>Get sh*it done · Mindre stress · mere kærlighed</p>
        </div>

        {/* Login buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
          <button
            onClick={handleGoogle}
            disabled={loading !== null}
            style={{
              padding: '14px 16px',
              borderRadius: 12,
              border: '1px solid #2D2A26',
              background: '#1A1917',
              color: '#F5F2EC',
              fontSize: 15,
              fontWeight: 600,
              cursor: loading ? 'wait' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 10,
              opacity: loading && loading !== 'google' ? 0.5 : 1,
            }}
          >
            <svg width="20" height="20" viewBox="0 0 48 48">
              <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
              <path fill="#FF3D00" d="m6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691z"/>
              <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
              <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
            </svg>
            {loading === 'google' ? 'Logger ind...' : 'Fortsæt med Google'}
          </button>

          <button
            onClick={handleFacebook}
            disabled={loading !== null}
            style={{
              padding: '14px 16px',
              borderRadius: 12,
              border: 'none',
              background: '#1877F2',
              color: 'white',
              fontSize: 15,
              fontWeight: 600,
              cursor: loading ? 'wait' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 10,
              opacity: loading && loading !== 'facebook' ? 0.5 : 1,
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669c1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            {loading === 'facebook' ? 'Logger ind...' : 'Fortsæt med Facebook'}
          </button>
        </div>

        {error && (
          <div style={{
            padding: '12px 14px',
            borderRadius: 10,
            background: 'rgba(239, 68, 68, 0.15)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            color: '#F87171',
            fontSize: 13,
            marginBottom: 16,
          }}>
            {error}
          </div>
        )}

        <p style={{ fontSize: 11, color: '#6B665D', textAlign: 'center', marginTop: 20, lineHeight: 1.6 }}>
          Ved at logge ind accepterer du vores <a href="/handelsbetingelser" style={{ color: '#A19B8F' }}>handelsbetingelser</a> og <a href="/privatlivspolitik" style={{ color: '#A19B8F' }}>privatlivspolitik</a>.
        </p>
      </div>
    </div>
  );
}
